//
//
//
//
//
//

import { TRUE } from '@/scripts/constants/booleans'
import {
  HAS_REQUEST_PROMOCODE,
  UPPERCASE_NONE,
  UPPERCASE_USER_CLUSTER,
  DCPARAM,
} from '@/scripts/constants/early-access'
import { EARLY_ACCESS } from '@/scripts/constants/promos'
import wcs from '@/scripts/libs/wcs'
import { WcsUser } from '@/scripts/libs/wcs/user'
import PromoStripe from '../libs/promo-stripe/promo-stripe'

const { earlyAccess } = wcs.getStoreConfig()

export default {
  name: 'rb-conditional-content',
  props: {
    params: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    evaluateQuery(params) {
      const promocodeToApply = PromoStripe.getPromoCode(window.location.search)

      if (promocodeToApply) {
        sessionStorage.setItem('promoCodeToApplyEvaluateQuery', promocodeToApply)
      }

      const promoCodeFromSessionStorage = sessionStorage.getItem('promoCodeToApplyEvaluateQuery')
      if (params && params.length > 0) {
        switch (params[0].key) {
          case HAS_REQUEST_PROMOCODE:
            if (params[0].value === TRUE && (promocodeToApply || promoCodeFromSessionStorage)) {
              return true
            } else {
              return false
            }

          case UPPERCASE_USER_CLUSTER:
            switch (params[0].value) {
              case EARLY_ACCESS:
                return (
                  earlyAccess.active &&
                  (WcsUser.isEarlyAccessActivityInUserClusterCookie() ||
                    WcsUser.getUserClusterFromWcs().includes(EARLY_ACCESS))
                )
              case UPPERCASE_NONE:
                return (
                  earlyAccess.active &&
                  !WcsUser.isEarlyAccessActivityInUserClusterCookie() &&
                  !WcsUser.getUserClusterFromWcs().includes(EARLY_ACCESS)
                )
              default:
                return false
            }

          case DCPARAM:
            return params.find((el) => el.key === DCPARAM).value === promoCodeFromSessionStorage

          default:
            return true
        }
      } else {
        return true
      }
    },
  },
}
